<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="title">Acente</h3>
                <a href="javascript:void(0)" @click="show" :href="basePath+'/agencies/new'" class="theme-btn theme-btn-small">
                  <i class="la la-plus mr-1"></i>
                  Acente Yarat
                </a>
              </div>
            </div>
            <div class="form-content pb-2">

              <h3 class="title">Acente List</h3>
              <p class="font-size-14" v-if="agencyList != null">{{ agencyList.length }} listeleniyor</p>

              <div class="table-form table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th scope="col">No</th>
                    <th>Adı</th>
                    <th>Market</th>
                    <th>WebService Ödeme Yapma</th>
                    <th>Parçalı Ödeme Yapma</th>
                    <th>Çoklu Oda Seçimi</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="agency in agencyList">
                    <th scope="row"><a :href="basePath+'/agencies/'+agency.id">#{{agency.id}}</a></th>
                    <th>{{ agency.name }}</th>
                    <th v-if="marketMap != null">{{ marketMap[agency.marketId].name }}</th>
                    <th v-else></th>
                    <th v-if="agency.webServiceAccess">✓</th>
                    <th v-else>x</th>
                    <th v-if="agency.canTakePartialPayment">✓</th>
                    <th v-else>x</th>
                    <th v-if="agency.canBookMultipleRooms">✓</th>
                    <th v-else>x</th>
                    <td>
                      <div class="table-content">
                        <a :href="basePath+'/agencies/'+agency.id" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                          <i class="la la-edit"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgencyList",
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList;
      }
    },
    agency:{
      get(){
        return this.$store.getters.getAgency;
      }
    },
    marketMap:{
      get(){
        return this.$store.getters.getMarketMap;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    show(){
      this.$store.commit("setAgency",{id:null,image:{}});
    },
  },
}
</script>

<style scoped>

</style>